import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  size: 'small' | 'medium' | 'large';
};

export const Banner = styled.div<Props>(
  ({theme, size}) => css`
    float: right;
    width: ${{
      small: '40px',
      medium: '60px',
      large: '74px',
    }[size]};
    margin-top: ${{
      small: '-12px',
      medium: '-12px',
      large: '-16px',
    }[size]};
    margin-left: 16px;
    padding: ${{
      small: '8px',
      medium: '12px',
      large: '16px',
    }[size]};
    background-color: ${theme.colors.backgroundPrimary};
    border-radius: 0 0 5px 5px;
    ${theme.elevations.small};
  `
);
